import {
  Epic,
  EpicCollection,
  EpicWithStoryCollection,
  Story,
  StoryCollection,
  Note,
  JiraProject,
  JiraEpicCollection,
  EpicToStoryMap,
  EpicsMap,
  CreateEpicAndStoriesResponse
} from '../../common/Types';

export enum UserStoreActionTypes {
  BulkCreateEpic = 'BULK_CREATE_EPIC',
  BulkCreateStory = 'BULK_CREATE_STORY',
  BulkCreateEpicWithStory = 'BULK_CREATE_EPIC_WITH_STORY',
  DeleteEpic = 'DELETE_EPIC',
  RemoveEpic = 'REMOVE_EPIC',
  DeleteStory = 'DELETE_STORY',
  BulkDeleteEpic = 'BULK_DELETE_EPIC',
  UpdateEpic = 'UPDATE_EPIC',
  UpdateStory = 'UPDATE_STORY',
  AssignEpicToStory = 'ASSIGN_EPIC_TO_STORY',
  SelectEpic = 'SELECT_EPIC',
  SelectEpicForBulk = 'SELECT_EPIC_FOR_BULK',
  UnSelectEpicForBulk = 'UNSELECT_EPIC_FOR_BULK',
  SelectStory = 'SELECT_STORY',
  UnSelectStory = 'UNSELECT_STORY',
  SaveUserNotesHistory = 'SAVE_USER_NOTES_HISTORY',
  LoadJiraEpic = 'LOAD_JIRA_EPIC',
  SetCurrentProject = 'SET_CURRENT_PROJECT',
  ResetIssues = 'RESET_ISSUES',
  PublishToJira = 'PUBLISH_TO_JIRA',
  ResetStoryEpicChangeState = 'RESET_STORY_EPIC_CHANGE_STATE',
  // New action types for chat message animation
  AddPendingUserMessage = 'ADD_PENDING_USER_MESSAGE',
  RemovePendingUserMessage = 'REMOVE_PENDING_USER_MESSAGE',
  MarkPendingUserMessageFailed = 'MARK_PENDING_USER_MESSAGE_FAILED'
}

export type SectionType = 'epics' | 'stories' | 'tasks';

export type UserStoryState = EpicWithStoryCollection &
  JiraEpicCollection & {
    epicToStoryMap: EpicToStoryMap;
    selectedEpic: string | null;
    selectedStories: string[];
    selectedEpics: string[];
    nextEpicIncrementKey: number;
    nextStoryIncrementKey: number;
    notes: Note[];
    currentProject: JiraProject;
    selectedStoryIdToEdit: string;
    selectedEpicIdToEdit: string;
    sectionCreationOrder: SectionType[];
  };

export type UserStoryStorePayload = {
  [UserStoreActionTypes.BulkCreateEpic]: { epicCollection: EpicCollection; userNotes: Note };
  [UserStoreActionTypes.BulkCreateStory]: {
    skipHistoryPrompt?: boolean;
    storyCollection: StoryCollection;
    userNotes: Note;
  };
  [UserStoreActionTypes.BulkCreateEpicWithStory]: {
    epicWithStoryCollection: EpicWithStoryCollection;
    userNotes: Note;
  };
  [UserStoreActionTypes.DeleteEpic]: string;
  [UserStoreActionTypes.RemoveEpic]: string;
  [UserStoreActionTypes.DeleteStory]: string[];
  [UserStoreActionTypes.BulkDeleteEpic]: string[];
  [UserStoreActionTypes.UpdateEpic]: { id: string; value: Epic };
  [UserStoreActionTypes.UpdateStory]: { id: string; value: Story };
  [UserStoreActionTypes.AssignEpicToStory]: {
    epicId?: string;
    storyIds: string[];
    isBulkAssign: boolean;
  };
  [UserStoreActionTypes.SelectEpic]: string | null;
  [UserStoreActionTypes.SelectEpicForBulk]: string[];
  [UserStoreActionTypes.UnSelectEpicForBulk]: string[];
  [UserStoreActionTypes.SelectStory]: string[];
  [UserStoreActionTypes.UnSelectStory]: string[];
  [UserStoreActionTypes.SaveUserNotesHistory]: Note;
  [UserStoreActionTypes.LoadJiraEpic]: EpicsMap;
  [UserStoreActionTypes.SetCurrentProject]: JiraProject;
  [UserStoreActionTypes.ResetIssues]: undefined;
  [UserStoreActionTypes.PublishToJira]: {
    epics: CreateEpicAndStoriesResponse;
    stories: CreateEpicAndStoriesResponse;
  };
  [UserStoreActionTypes.ResetStoryEpicChangeState]: {
    storyIds: string[];
    epicIds?: string[];
  };
  // New action payloads for chat message animation
  [UserStoreActionTypes.AddPendingUserMessage]: Note;
  [UserStoreActionTypes.RemovePendingUserMessage]: { timestamp: Date };
  [UserStoreActionTypes.MarkPendingUserMessageFailed]: { timestamp: Date };
};
